import fieldsetComponent from "@/components/child/form/fieldset.vue";
import { Component } from "@/decorators";
import Vue from "vue";

import ColetaModel from "@/models/expedicao/coletaModel";
import ColetaService from "@/services/expedicao/coletaService";

import moment from "moment";
import "../crud.scss";

@Component({
    components: {
        fieldsetComponent,
    },
})
export default class ColetaVerComponent extends Vue {
    private model: ColetaModel = new ColetaModel();
    private coletaService: ColetaService = new ColetaService();

    public load(coletaId: number): void {
        this.coletaService
            .getToModal(coletaId)
            .withLoading()
            .resolveWithJSON<ColetaModel>()
            .then(response => (this.model = response));
    }

    formatData(data: Date): string {
        return moment(data).format("DD/MM/YYYY hh:mm");
    }
}
